import api from './axiosApi'
import type {
  AdminUser,
  PaginatedAdminUsersResponse,
  UserRole,
} from '@/types/adminUser'

interface ListAdminUsersParams {
  search?: string
  role?: UserRole
  skip?: number
  limit?: number
}

export async function listAdminUsers(
  params: ListAdminUsersParams = {}
): Promise<PaginatedAdminUsersResponse> {
  const { search, role, skip = 0, limit = 20 } = params

  const response = await api.get<PaginatedAdminUsersResponse>('/admin/users', {
    params: {
      search: search || undefined,
      role: role || undefined,
      skip,
      limit,
    },
  })

  return response.data
}

export async function updateUserRole(
  userId: string,
  role: UserRole
): Promise<AdminUser> {
  const response = await api.put<AdminUser>(`/admin/users/${userId}/role`, {
    role,
  })
  return response.data
}

export async function activateUser(userId: string): Promise<AdminUser> {
  const response = await api.post<AdminUser>(`/admin/users/${userId}/activate`)
  return response.data
}

export async function deactivateUser(userId: string): Promise<AdminUser> {
  const response = await api.post<AdminUser>(
    `/admin/users/${userId}/deactivate`
  )
  return response.data
}
